import { Button, Form, Input, message } from "antd";
import axios from "axios";
import * as moment from "moment";
import React, { useEffect } from "react";
import { FiPaperclip } from "react-icons/fi";
import { useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { cloudFrontUrl, serverUrl } from "../../nestserver";
import { selectUser } from "../../redux/slices/auth.slice";
import { useCreateNotification } from "../../services/notification.service";
import { numberInputGuard } from "../inputs/numberInputGuard";

export default function ExamEvaluationForm({ data, onClose }) {
  const [form] = Form.useForm();
  const queryClient = useQueryClient();

  const user = useSelector(selectUser);

  const createNotificationMutation = useCreateNotification();

  const onFinish = (values) => {
    axios({
      method: "patch",
      url: serverUrl + "/exam-submissions/" + data?._id,
      data: {
        ...values,
        status: values.status ?? "evaluated",
      },
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    })
      .then((res) => {
        message.success("Submission Updated");
        queryClient.invalidateQueries(["exam-submissions", data?.exam?._id]);
        createNotificationMutation.mutate({
          title: values?.status ? "Exam needs to resubmit" : "Exam evaluated",
          description: ` ${
            values?.status
              ? `${user?.teacher?.first_name} requested you to resubmit ${
                  data?.exam?.subject?.name
                } ${data?.exam?.name} on ${moment().format("MMM Do YYYY")}`
              : `${user?.teacher?.first_name} evaluated your ${
                  data?.exam?.subject?.name
                } ${data?.exam?.name} on ${moment().format("MMM Do YYYY")}`
          }`,
          user: data?.student?._id,
          type: "exam",
        });
        onClose && onClose();
      })
      .catch((e) => {
        message.error(e.message);
      });
  };
  useEffect(() => {
    if (data?.exam) {
      form.setFieldsValue({
        remarks: data?.remarks,
        score: data?.score,
      });
    }
  }, [data?.exam]);
  return (
    <div>
      <div className="text-xl font-bold text-black1 pb-6">
        {data?.student?.first_name} {data?.student?.last_name}
      </div>
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={onFinish}
        autoComplete="off"
      >
        <div className="pb-2 space-y-1">
          <div className="text-primary text-base">Exam Name</div>
          <div className=" font-medium text-base">{data?.exam?.name}</div>
        </div>

        <div className="flex flex-col space-y-1 pb-2">
          <div className="text-base font-normal text-primary">
            Class & Subject
          </div>
          <div className="text-base font-normal ">
            {data?.exam?.class?.name}, {data?.exam?.subject?.name}
          </div>
        </div>
        <div className="flex flex-col space-y-1 pb-2">
          <div className="text-base font-normal text-primary pb-1">Modules</div>
          <div className="flex flex-row space-x-4">
            {data?.exam?.modules?.map((module) => (
              <Button
                key={module?._id}
                type="primary"
                className="cursor-default"
              >
                {module?.title}
              </Button>
            ))}
          </div>
        </div>

        <div className="capitalize py-4">
          {/* <Button
            type="primary"
            size="large"
            //    onClick={}
          >
            Downlaod
          </Button> */}
          <div>Attachment : </div>
          <div>
            {data?.file.map((item) => (
              <div
                key={item?.id}
                className="flex flex-row items-center space-x-3 py-2 "
              >
                <FiPaperclip />
                <a
                  href={cloudFrontUrl + "/docs/" + item?.id}
                  target="_blank"
                  rel="noreferrer"
                >
                  {item?.files?.name}
                </a>
              </div>
            ))}
          </div>
        </div>

        <Form.Item
          label={`Score out of ${data?.exam?.score}`}
          name="score"
          rules={[
            {
              required: true,
              message: "Please input  score !",
            },
            {
              pattern: /^[1-9]\d*$/,
              message: "Please enter a positive number ",
            },
          ]}
        >
          <Input
            type="number"
            max={data?.exam?.score}
            className="w-36 "
            placeholder={data?.exam?.score}
            disabled={user?.role === "parent"}
            {...numberInputGuard}
          />
        </Form.Item>

        <Form.Item label="Remarks" name="remarks">
          <Input className="w-full py-1" disabled={user?.role === "parent"} />
        </Form.Item>

        <Form.Item className="mb-0 pt-2">
          <div className="flex items-center">
            <div className="inline-block ml-auto space-x-4">
              <Button
                disabled={data?.enable_resubmission || user?.role === "parent"}
                type="primary"
                size="large"
                onClick={() =>
                  onFinish({
                    score: null,
                    enable_resubmission: true,
                    status: "resubmit",
                  })
                }
              >
                Resubmit
              </Button>
              <Button
                type="success"
                size="large"
                htmlType="submit"
                disabled={user?.role === "parent"}
              >
                Mark As Complete
              </Button>
            </div>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
}
